var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dashboard",class:_vm.pageClass},[_c('div',{staticClass:"page-bg",style:(_vm.pageStyle)}),_c('div',{staticClass:"container"},[_c(_vm.painelDevice,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }